import { CloseRounded } from '@mui/icons-material';
import {
  Box,
  CircularProgress,
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
  Typography,
} from '@mui/material';
import PdfViewer from './Viewer';

interface ViewerFileProps {
  open: boolean;
  onClose: () => void;
  title: string;
  loading: boolean;
  fileUrl: string;
  fileId: string;
  isEbook?: boolean;
  isMinute?: boolean;
}

export const ViewerFile = ({
  open,
  onClose,
  title,
  loading,
  fileUrl = '',
  fileId,
  isEbook = false,
  isMinute = false,
}: ViewerFileProps) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      fullWidth
      keepMounted
      aria-describedby="alert-dialog-slide-description"
      sx={{
        width: '100%',
        height: '100%',
      }}
      PaperProps={{
        sx: {
          height: '100%',
          width: '100%',
          maxHeight: 'none',
          maxWidth: 'none',
          margin: '0',
          borderRadius: '0px',
          backgroundColor: '#5f5f5f',
          overflow: 'hidden',
        },
      }}
    >
      <Box width="100%" height="100%" position="relative">
        <DialogTitle
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            padding: '5px 10px',
            backgroundColor: 'rgb(238, 238, 238)',
            position: 'fixed',
            height: '52px',
            width: '100%',
            zIndex: 10,
          }}
        >
          <Typography
            sx={{
              color: '#000000',
              fontFamily: 'Roboto',
              fontWeight: '500',
              fontSize: '19px',
              lineHeight: '29px',
            }}
          >
            {title}
          </Typography>
          <IconButton onClick={onClose}>
            <CloseRounded sx={{ fontSize: '25px', color: '#000000' }} />
          </IconButton>
        </DialogTitle>
        {loading ? (
          <Box
            width="100%"
            height="100%"
            padding="20px"
            display="flex"
            justifyContent="center"
            alignItems="center"
          >
            <CircularProgress />
          </Box>
        ) : (
          <DialogContent
            sx={{
              height: 'fit-content',
              padding: 0,
              marginTop: '52px',
            }}
          >
            {fileUrl && (
              // <WaterMark
              //   fileUrl={fileUrl}
              //   fileId={fileId}
              //   isEbook={isEbook}
              //   fileName={title}
              //   isMinute={isMinute}
              // />
              <PdfViewer
                fileUrl={fileUrl}
                fileId={fileId}
                isEbook={isEbook}
                fileName={title}
                isMinute={isMinute}
              />
            )}
          </DialogContent>
        )}
      </Box>
    </Dialog>
  );
};
